import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { uniq } from 'lodash';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import { getFormValues, change } from 'redux-form';

import IconButton from 'components/common/IconButton';
import Tooltip from 'components/common/Tooltip';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import Link from 'components/common/Link';
import Avatar from 'components/common/Avatar';
import InventoryCreateEditDialog from 'components/inventory/InventoryCreateEditDialog';
import VendorCreateEditDialog from 'components/vendor/VendorCreateEditDialog';
import InventoryStockLineHistoryViewDialog from 'components/inventory/InventoryStockLineHistoryViewDialog';
import InventoryCategoryCreateEditDialog from 'components/settings/InventoryCategoryCreateEditDialog';
import InventoryConditionCreateEditDialog from 'components/settings/InventoryConditionCreateEditDialog';
import InventoryWarehouseCreateEditDialog from 'components/settings/InventoryWarehouseCreateEditDialog';
import IconBox from 'components/icons/IconBox';
import DocumentsViewDialog from 'components/common/DocumentsViewDialog';
import IconTransmit from 'components/icons/IconTransmit';
import IconCash from 'components/icons/IconCash';

import formatSinglePlural from 'utils/formatSinglePlural';
import formatPrice from 'utils/formatPrice';

import { deleteInventory } from 'redux/modules/inventory';

import VendorInformation from 'components/vendor/VendorInformation';

import InventoryTableRowHCPCCodes from './InventoryTableRowHCPCCodes';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  codesCell: {
    paddingRight: 0,
  },
  linkProductName: {
    display: 'inline-block',
    wordBreak: 'break-word',
  },
  linkVendorName: {
    display: 'inline-block',
    wordBreak: 'break-word',
  },
  avatar: {
    marginTop: -4,
    marginBottom: -4,
  },
  iconBox: {
    width: 34,
    height: 34,
  },
  statusIcon: {
    display: 'inline-block',
    width: 10,
    height: 10,
    borderRadius: '50%',
    overflow: 'hidden',
    textIndent: '100%',
    cursor: 'pointer',
  },
  statusIconActive: {
    backgroundColor: theme.palette.active[500],
  },
  statusIconInactive: {
    backgroundColor: theme.palette.validation[500],
  },
  iconTransmit: {
    width: 14,
    height: 14,
  },
  iconCash: {
    width: 20,
    height: 20,
  },
  tooltipRetailUsed: {
    marginLeft: 4,
    verticalAlign: 'middle',
    color: theme.palette.primary[500],
  },
});

class InventoryTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
      editDialogOpen: false,
      editFormValues: null,
      vendorCreateDialogOpen: false,
      categoryCreateDialogOpen: false,
      conditionCreateDialogOpen: false,
      warehouseCreateDialogOpen: false,
      copyDialogOpen: false,
      copyFormValues: null,
      stockLineCreateEditDialogOpen: false,
      stockLineHistoryViewDialogOpen: false,
      stockLineEditInitialValues: null,
      imageViewDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogEnter = this.onEditDialogEnter.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
    this.onVendorCreate = this.onVendorCreate.bind(this);
    this.onVendorCreateDialogSubmitSuccess = this.onVendorCreateDialogSubmitSuccess.bind(this);
    this.onVendorCreateDialogClose = this.onVendorCreateDialogClose.bind(this);
    this.onCategoryCreate = this.onCategoryCreate.bind(this);
    this.onCategoryCreateDialogSubmitSuccess = this.onCategoryCreateDialogSubmitSuccess.bind(this);
    this.onCategoryCreateDialogClose = this.onCategoryCreateDialogClose.bind(this);
    this.onConditionCreate = this.onConditionCreate.bind(this);
    this.onConditionCreateDialogSubmitSuccess =
      this.onConditionCreateDialogSubmitSuccess.bind(this);
    this.onConditionCreateDialogClose = this.onConditionCreateDialogClose.bind(this);
    this.onWarehouseCreate = this.onWarehouseCreate.bind(this);
    this.onWarehouseCreateDialogSubmitSuccess =
      this.onWarehouseCreateDialogSubmitSuccess.bind(this);
    this.onWarehouseCreateDialogClose = this.onWarehouseCreateDialogClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onCopyMenuItemClick = this.onCopyMenuItemClick.bind(this);
    this.onCopyDialogEnter = this.onCopyDialogEnter.bind(this);
    this.onCopyDialogClose = this.onCopyDialogClose.bind(this);
    this.onStockLineCreateItemClick = this.onStockLineCreateItemClick.bind(this);
    this.onStockLineCreateEditDialogClose = this.onStockLineCreateEditDialogClose.bind(this);
    this.onStockLineHistoryViewLinkClick = this.onStockLineHistoryViewLinkClick.bind(this);
    this.onStockLineHistoryViewDialogClose = this.onStockLineHistoryViewDialogClose.bind(this);
    this.onStockLineCreateDialogCopyButtonClick =
      this.onStockLineCreateDialogCopyButtonClick.bind(this);
    this.onStockLineEdit = this.onStockLineEdit.bind(this);
    this.onImageViewDialogClose = this.onImageViewDialogClose.bind(this);
    this.onImageViewLinkClick = this.onImageViewLinkClick.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      editDialogOpen: true,
      anchorEl: null,
    });
  }

  onEditDialogEnter() {
    const { ID, actions } = this.props;
    const { editFormValues } = this.state;
    if (editFormValues) {
      Object.keys(editFormValues).forEach((key) => {
        actions.change(`${ID}-inventoryEdit`, key, editFormValues[key]);
      });
      this.setState({ editFormValues: null });
    }
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  onVendorCreate() {
    this.setState({
      ...this.state.editDialogOpen ? {
        editFormValues: this.props.editFormValues,
        editDialogOpen: false,
      } : {},
      ...this.state.copyDialogOpen ? {
        copyFormValues: this.props.copyFormValues,
        copyDialogOpen: false,
      } : {},
      vendorCreateDialogOpen: true,
    });
  }

  onVendorCreateDialogSubmitSuccess(values) {
    this.setState({
      vendorCreateDialogOpen: false,
      ...this.state.editFormValues ? {
        editDialogOpen: true,
        editFormValues: {
          ...this.state.editFormValues,
          ...{
            'Vendor Name': values['Vendor Name'],
            'Vendor ID': values.ID,
          },
        },
      } : {},
      ...this.state.copyFormValues ? {
        copyDialogOpen: true,
        copyFormValues: {
          ...this.state.copyFormValues,
          ...{
            'Vendor Name': values['Vendor Name'],
            'Vendor ID': values.ID,
          },
        },
      } : {},
    });
  }

  onVendorCreateDialogClose() {
    this.setState({
      vendorCreateDialogOpen: false,
      editDialogOpen: true,
    });
  }

  onCategoryCreate() {
    this.setState({
      ...this.state.editDialogOpen ? {
        editFormValues: this.props.editFormValues,
        editDialogOpen: false,
      } : {},
      ...this.state.copyDialogOpen ? {
        copyFormValues: this.props.copyFormValues,
        copyDialogOpen: false,
      } : {},
      categoryCreateDialogOpen: true,
    });
  }

  onCategoryCreateDialogSubmitSuccess(values) {
    this.setState({
      categoryCreateDialogOpen: false,
      ...this.state.editFormValues ? {
        editDialogOpen: true,
        editFormValues: {
          ...this.state.editFormValues,
          ...{
            'Category Name': values.Name,
            'Selected Category Name': values.Name,
            'Category ID': values.ID,
          },
        },
      } : {},
      ...this.state.copyFormValues ? {
        copyDialogOpen: true,
        copyFormValues: {
          ...this.state.copyFormValues,
          ...{
            'Category Name': values.Name,
            'Selected Category Name': values.Name,
            'Category ID': values.ID,
          },
        },
      } : {},
    });
  }

  onCategoryCreateDialogClose() {
    this.setState({
      categoryCreateDialogOpen: false,
      editDialogOpen: true,
    });
  }

  onConditionCreate() {
    this.setState({
      ...this.state.editDialogOpen ? {
        editFormValues: this.props.editFormValues,
        editDialogOpen: false,
      } : {},
      ...this.state.copyDialogOpen ? {
        copyFormValues: this.props.copyFormValues,
        copyDialogOpen: false,
      } : {},
      conditionCreateDialogOpen: true,
    });
  }

  onConditionCreateDialogSubmitSuccess(values) {
    this.setState({
      conditionCreateDialogOpen: false,
      ...this.state.editFormValues ? {
        editDialogOpen: true,
        editFormValues: {
          ...this.state.editFormValues,
          ...{
            'Condition Name': values.Name,
            'Selected Condition Name': values.Name,
            'Condition ID': values.ID,
          },
        },
      } : {},
      ...this.state.copyFormValues ? {
        copyDialogOpen: true,
        copyFormValues: {
          ...this.state.copyFormValues,
          ...{
            'Condition Name': values.Name,
            'Selected Condition Name': values.Name,
            'Condition ID': values.ID,
          },
        },
      } : {},
    });
  }

  onConditionCreateDialogClose() {
    this.setState({
      conditionCreateDialogOpen: false,
      editDialogOpen: true,
    });
  }

  onWarehouseCreate() {
    this.setState({
      ...this.state.editDialogOpen ? {
        editFormValues: this.props.editFormValues,
        editDialogOpen: false,
      } : {},
      ...this.state.copyDialogOpen ? {
        copyFormValues: this.props.copyFormValues,
        copyDialogOpen: false,
      } : {},
      warehouseCreateDialogOpen: true,
    });
  }

  onWarehouseCreateDialogSubmitSuccess(values) {
    this.setState({
      warehouseCreateDialogOpen: false,
      ...this.state.editFormValues ? {
        editDialogOpen: true,
        editFormValues: {
          ...this.state.editFormValues,
          ...{
            'Warehouse Location': values.Location,
            'Selected Warehouse Location': values.Location,
            'Warehouse ID': values.ID,
          },
        },
      } : {},
      ...this.state.copyFormValues ? {
        copyDialogOpen: true,
        copyFormValues: {
          ...this.state.copyFormValues,
          ...{
            'Warehouse Location': values.Location,
            'Selected Warehouse Location': values.Location,
            'Warehouse ID': values.ID,
          },
        },
      } : {},
    });
  }

  onWarehouseCreateDialogClose() {
    this.setState({
      warehouseCreateDialogOpen: false,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteInventory({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onCopyMenuItemClick() {
    this.setState({
      copyDialogOpen: true,
      anchorEl: null,
    });
  }

  onCopyDialogEnter() {
    const { ID, actions } = this.props;
    const { copyFormValues } = this.state;
    if (copyFormValues) {
      Object.keys(copyFormValues).forEach((key) => {
        actions.change(`${ID}-inventoryCopy`, key, copyFormValues[key]);
      });
      this.setState({ copyFormValues: null });
    }
  }

  onCopyDialogClose() {
    this.setState({ copyDialogOpen: false });
  }

  onStockLineCreateItemClick() {
    this.setState({
      stockLineCreateEditDialogOpen: true,
      anchorEl: null,
    });
  }

  onStockLineCreateEditDialogClose() {
    const { stockLineEditInitialValues } = this.state;
    const newState = {
      stockLineCreateEditDialogOpen: false,
    };
    if (stockLineEditInitialValues) {
      newState.stockLineEditInitialValues = null;
      newState.stockLineHistoryViewDialogOpen = true;
    }
    this.setState(newState);
  }

  onStockLineHistoryViewLinkClick() {
    this.setState({ stockLineHistoryViewDialogOpen: true });
  }

  onStockLineHistoryViewDialogClose() {
    this.setState({ stockLineHistoryViewDialogOpen: false });
  }

  onStockLineCreateDialogCopyButtonClick() {
    this.setState({
      stockLineCreateEditDialogOpen: false,
      copyDialogOpen: true,
    });
  }

  onStockLineEdit(values) {
    this.setState({
      stockLineHistoryViewDialogOpen: false,
      stockLineCreateEditDialogOpen: true,
      stockLineEditInitialValues: values,
    });
  }

  onImageViewLinkClick() {
    this.setState({ imageViewDialogOpen: true });
  }

  onImageViewDialogClose() {
    this.setState({ imageViewDialogOpen: false });
  }

  render() {
    const {
      ID,
      Vendor,
      Category,
      Condition,
      Warehouse,
      Image,
      Model,
      Facility,
      account,
      business,
      classes,
      onProductCopySuccess,
    } = this.props;
    const {
      anchorEl,
      editDialogOpen,
      deleteMenuOpen,
      vendorCreateDialogOpen,
      categoryCreateDialogOpen,
      conditionCreateDialogOpen,
      warehouseCreateDialogOpen,
      copyDialogOpen,
      stockLineCreateEditDialogOpen,
      stockLineHistoryViewDialogOpen,
      stockLineEditInitialValues,
    } = this.state;
    const open = Boolean(anchorEl);
    // const totalQuantity = this.props['Stock Line']
    //   .reduce((accumulator, currentValue) =>
    //     accumulator + currentValue.Quantity,
    //   0,
    //   );
    // const totalPrice = Math.round(this.props['Stock Line']
    //   .reduce((accumulator, currentValue) => (currentValue.Quantity && currentValue.Price
    //     ? accumulator + (currentValue.Quantity * currentValue.Price)
    //     : accumulator
    //   ), 0,
    //   ) * 100) / 100;
    const lastStockLine = this.props['Last Arrival Stock Line'];
    const HCPCCodesQuantity = this.props['HCPC Codes']
      .reduce((accumulator, currentValue) =>
        accumulator + currentValue.length,
      0,
      );
    let imageSrc;
    if (Image.length > 0) {
      imageSrc = process.env.REACT_APP_API_ROOT
        ? `${process.env.REACT_APP_API_ROOT}${Image[0]['File Url']}${Image[0]['File Name']}`
        : `${Image[0]['File Url']}${Image[0]['File Name']}`;
    }

    return (
      <TableRow>
        <TableCell>
          {Image[0] ? (
            <Fragment>
              <Link
                onClick={this.onImageViewLinkClick}
              >
                <Avatar
                  className={classes.avatar}
                  src={imageSrc}
                  variant="square"
                  placeholderImage={(
                    <IconBox className={classes.iconBox} />
                  )}
                />
              </Link>
              <DocumentsViewDialog
                open={this.state.imageViewDialogOpen}
                onClose={this.onImageViewDialogClose}
                Documents={Image}
                initialDocumentID={Image[0].ID}
              />
            </Fragment>
          ) : (
            <Avatar
              className={classes.avatar}
              src={imageSrc}
              variant="square"
              placeholderImage={(
                <IconBox className={classes.iconBox} />
              )}
            />
          )}
        </TableCell>
        <TableCell>
          <Tooltip
            content={
              <Typography>
                {this.props['Is Active'] === true ? 'Active' : 'Inactive'}
              </Typography>
            }
            placement="top"
          >
            <div
              className={classNames(classes.statusIcon, {
                [classes.statusIconActive]: this.props['Is Active'] === true,
                [classes.statusIconInactive]: this.props['Is Active'] === false,
              })}
            />
          </Tooltip>
        </TableCell>
        <TableCell>
          <Link
            className={classes.linkProductName}
            onClick={this.onStockLineHistoryViewLinkClick}
          >
            {this.props['Product Name']}
          </Link>
        </TableCell>
        <TableCell>
          {Model}
        </TableCell>
        <TableCell>
          <Tooltip
            content={
              <VendorInformation {...Vendor} />
            }
            placement="bottom"
            color="grey"
          >
            <Link className={classes.linkVendorName}>
              {Vendor ? Vendor['Vendor Name'] : ''}
            </Link>
          </Tooltip>
        </TableCell>
        <TableCell>
          {Category ? Category.Name : ''}
        </TableCell>
        <TableCell>
          {Condition ? Condition.Name : ''}
        </TableCell>
        <TableCell>
          {!this.props['Calories Per Unit'] && lastStockLine && lastStockLine['Quantity In Case']
            ? Math.round(this.props['Stock Line Balance'] / lastStockLine['Quantity In Case']) : ''}
          {this.props['Calories Per Unit'] && lastStockLine && lastStockLine['Quantity In Case']
            ? Math.round((this.props['Stock Line Balance'] * 100) / (lastStockLine['Quantity In Case'] * this.props['Calories Per Unit'])) : ''}
        </TableCell>
        <TableCell>
          {lastStockLine && lastStockLine['Quantity In Case'] ? lastStockLine['Quantity In Case'] : ''}
        </TableCell>
        <TableCell>
          {`${this.props['Stock Line Balance']}${'\u00A0'}${this.props['Calories Per Unit'] ? 'Cal' : ''}${'\u00A0'}${formatSinglePlural({
            quantity: this.props['Stock Line Balance'],
            single: 'Unit',
            plural: 'Units',
          })}`}
        </TableCell>
        <TableCell>
          {lastStockLine && lastStockLine.Price ? formatPrice(lastStockLine.Price) : ''}
        </TableCell>
        <TableCell>
          {lastStockLine && lastStockLine['Retail Price'] ? formatPrice(lastStockLine['Retail Price']) : ''}
          {lastStockLine['Is Retail Price For Claims'] &&
            <Tooltip
              className={classes.tooltipRetailUsed}
              content="Used for Claims"
              placement="bottom"
              color="dark"
              disableGutters
            >
              <IconTransmit className={classes.iconTransmit} />
            </Tooltip>
          }
          {lastStockLine['Is Retail Price For Self Pay'] &&
            <Tooltip
              className={classes.tooltipRetailUsed}
              content="Used for Self Pay"
              placement="bottom"
              color="dark"
              disableGutters
            >
              <IconCash className={classes.iconCash} />
            </Tooltip>
          }
        </TableCell>
        <TableCell>
          {this.props['Stock Line Total Price'] ? formatPrice(this.props['Stock Line Total Price']) : ''} 
        </TableCell>
        <TableCell className={classes.codesCell}>
          {HCPCCodesQuantity > 1 &&
            (<Tooltip
              content={
                <InventoryTableRowHCPCCodes
                  {...{ 'HCPC Codes': this.props['HCPC Codes'] }}
                />
              }
              placement="bottom"
            >
              <Link>
                {`${HCPCCodesQuantity}${'\u00A0'}${formatSinglePlural({
                  quantity: HCPCCodesQuantity,
                  single: 'code',
                  plural: 'codes',
                })}`}
              </Link>
            </Tooltip>)
          }
          {HCPCCodesQuantity === 1 &&
            this.props['HCPC Codes'][0][0]['HCPC S Code']
          }
        </TableCell>
        <TableCell>
          {(Facility && Facility.length > 0) && uniq(Facility.map(item => item['Company Info']['Company Name'])).join(', ')}
        </TableCell>
        <TableCell>
          {this.props['Last Arrival Stock Line'] && this.props['Last Arrival Stock Line'].Warehouse
            ? this.props['Last Arrival Stock Line'].Warehouse.Location : ''}
        </TableCell>
        <TableCell
          className={classes.buttonCell}
          numeric
        >
          <IconButton
            aria-label="More"
            aria-owns={open ? `${ID}-inventory-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${ID}-inventory-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={244}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this inventory?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem onClick={this.onStockLineCreateItemClick}>
                  Add Inventory
                </MenuItem>
                <MenuItem onClick={this.onEditMenuItemClick}>
                  Edit
                </MenuItem>
                <MenuItem onClick={this.onCopyMenuItemClick}>
                  Clone Product
                </MenuItem>
                <MenuItem onClick={this.onStockLineHistoryViewLinkClick}>
                  View History Log
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
        <InventoryCreateEditDialog
          open={editDialogOpen}
          onEnter={this.onEditDialogEnter}
          onClose={this.onEditDialogClose}
          onVendorCreate={this.onVendorCreate}
          onCategoryCreate={this.onCategoryCreate}
          onConditionCreate={this.onConditionCreate}
          onWarehouseCreate={this.onWarehouseCreate}
          form={`${ID}-inventoryEdit`}
          variant="edit"
          initialValues={{
            ID,
            'Product Name': this.props['Product Name'],
            ...this.props['Retail Price'] ? {
              'Retail Price': formatPrice(this.props['Retail Price']),
            } : {},
            'Vendor Name': Vendor['Vendor Name'],
            'Vendor ID': Vendor.ID,
            Model,
            'HCPC Codes': this.props['HCPC Codes'].map(item => (
              item.map(nestedItem => nestedItem['HCPC S Code'])
            )),
            'Do not override': !this.props['Can Updated'],
            'Is Active': this.props['Is Active'],
            ...Category && Category.ID ? {
              'Category Name': Category.Name,
              'Selected Category Name': Category.Name,
              'Category ID': Category.ID,
            } : {},
            ...Condition && Condition.ID ? {
              'Condition Name': Condition.Name,
              'Selected Condition Name': Condition.Name,
              'Condition ID': Condition.ID,
            } : {},
            ...Warehouse && Warehouse.ID ? {
              'Warehouse Location': Warehouse.Location,
              'Selected Warehouse Location': Warehouse.Location,
              'Warehouse ID': Warehouse.ID,
            } : {},
            ...Image[0] ? {
              Image: Image.map(item => ({
                name: item['File Name'],
                preview: `${item['File Url']}${item['File Name']}`,
                ID: item.ID,
              })),
            } : {},
            'Calories Per Unit': this.props['Calories Per Unit'],
          }}
        />
        <InventoryCreateEditDialog
          open={copyDialogOpen}
          onEnter={this.onCopyDialogEnter}
          onClose={this.onCopyDialogClose}
          onVendorCreate={this.onVendorCreate}
          onCategoryCreate={this.onCategoryCreate}
          onConditionCreate={this.onConditionCreate}
          onWarehouseCreate={this.onWarehouseCreate}
          onSubmitSuccess={onProductCopySuccess}
          form={`${ID}-inventoryCopy`}
          variant="copy"
          initialValues={{
            'Product Name': this.props['Product Name'],
            ...this.props['Retail Price'] ? {
              'Retail Price': formatPrice(this.props['Retail Price']),
            } : {},
            'Vendor Name': Vendor['Vendor Name'],
            'Vendor ID': Vendor.ID,
            Model,
            'HCPC Codes': this.props['HCPC Codes'].map(item => (
              item.map(nestedItem => nestedItem['HCPC S Code'])
            )),
            'Do not override': false,
            'Is Active': this.props['Is Active'],
            ...Category && Category.ID ? {
              'Category Name': Category.Name,
              'Selected Category Name': Category.Name,
              'Category ID': Category.ID,
            } : {},
            ...Condition && Condition.ID ? {
              'Condition Name': Condition.Name,
              'Selected Condition Name': Condition.Name,
              'Condition ID': Condition.ID,
            } : {},
            ...Warehouse && Warehouse.ID ? {
              'Warehouse Location': Warehouse.Location,
              'Selected Warehouse Location': Warehouse.Location,
              'Warehouse ID': Warehouse.ID,
            } : {},
            ...Image[0] ? {
              Image: Image.map(item => ({
                name: item['File Name'],
                preview: `${item['File Url']}${item['File Name']}`,
                ID: item.ID,
              })),
              'Image ID': Image.ID,
            } : {},
            'Calories Per Unit': this.props['Calories Per Unit'],
          }}
        />
        <VendorCreateEditDialog
          form="vendorCreate"
          open={vendorCreateDialogOpen}
          onClose={this.onVendorCreateDialogClose}
          onSubmitSuccess={this.onVendorCreateDialogSubmitSuccess}
        />
        <InventoryCategoryCreateEditDialog
          form="inventoryCategoryCreate"
          open={categoryCreateDialogOpen}
          onClose={this.onCategoryCreateDialogClose}
          onSubmitSuccess={this.onCategoryCreateDialogSubmitSuccess}
        />
        <InventoryConditionCreateEditDialog
          form="inventoryConditionCreate"
          open={conditionCreateDialogOpen}
          onClose={this.onConditionCreateDialogClose}
          onSubmitSuccess={this.onConditionCreateDialogSubmitSuccess}
        />
        <InventoryWarehouseCreateEditDialog
          form="inventoryWarehouseCreate"
          open={warehouseCreateDialogOpen}
          onClose={this.onWarehouseCreateDialogClose}
          onSubmitSuccess={this.onWarehouseCreateDialogSubmitSuccess}
        />

        <InventoryCreateEditDialog
          open={stockLineCreateEditDialogOpen}
          onEnter={this.onEditDialogEnter}
          onClose={this.onStockLineCreateEditDialogClose}
          onVendorCreate={this.onVendorCreate}
          onCategoryCreate={this.onCategoryCreate}
          onConditionCreate={this.onConditionCreate}
          onWarehouseCreate={this.onWarehouseCreate}
          form={stockLineEditInitialValues
            ? `${stockLineEditInitialValues.ID}-inventoryStockLineEdit`
            : `${ID}-inventoryStockLineCreate`}
          variant={stockLineEditInitialValues ? 'stock-line-edit' : 'stock-line-create'}
          initialValues={{
            ID,
            'Product Name': this.props['Product Name'],
            ...this.props['Retail Price'] ? {
              'Retail Price': formatPrice(this.props['Retail Price']),
            } : {},
            'Vendor Name': Vendor['Vendor Name'],
            'Vendor ID': Vendor.ID,
            Model,
            'HCPC Codes': this.props['HCPC Codes'].map(item => (
              item.map(nestedItem => nestedItem['HCPC S Code'])
            )),
            'Do not override': !this.props['Can Updated'],
            'Is Active': this.props['Is Active'],
            ...Category && Category.ID ? {
              'Category Name': Category.Name,
              'Selected Category Name': Category.Name,
              'Category ID': Category.ID,
            } : {},
            ...Condition && Condition.ID ? {
              'Condition Name': Condition.Name,
              'Selected Condition Name': Condition.Name,
              'Condition ID': Condition.ID,
            } : {},
            ...Warehouse && Warehouse.ID ? {
              'Warehouse Location': Warehouse.Location,
              'Selected Warehouse Location': Warehouse.Location,
              'Warehouse ID': Warehouse.ID,
            } : {},
            ...Image[0] ? {
              Image: Image.map(item => ({
                name: item['File Name'],
                preview: `${item['File Url']}${item['File Name']}`,
                ID: item.ID,
              })),
            } : {},
            'Calories Per Unit': this.props['Calories Per Unit'],
            'Supply Type': (Category.Name === 'Enteral' || this.props['Calories Per Unit']) ? 'Kcal Units' : 'Units',
            ...(!this.props['Calories Per Unit'] && this.props['Last Arrival Stock Line'] && this.props['Last Arrival Stock Line']['Quantity In Case'])
              ? { 'Supply Type': 'Boxes' } : {},
            ...stockLineEditInitialValues ? {
              'Stock Line ID': stockLineEditInitialValues.ID,
              'Price per Unit': formatPrice(stockLineEditInitialValues.Price),
              'Units Quantity': stockLineEditInitialValues.Quantity,
              'Units in Box': stockLineEditInitialValues['Quantity In Case'],
              'Facility Name': stockLineEditInitialValues['Facility Name'],
              'Selected Facility Name': stockLineEditInitialValues['Selected Facility Name'],
              'Facility ID': stockLineEditInitialValues['Facility ID'],
              'Warehouse ID': stockLineEditInitialValues['Warehouse ID'],
              'Warehouse Location': stockLineEditInitialValues['Warehouse Location'],
              'Selected Warehouse Location': stockLineEditInitialValues['Selected Warehouse Location'],
              'Expiration Date': stockLineEditInitialValues['Expiration Date'],
              'Retail Price': stockLineEditInitialValues['Retail Price'],
              'Is Retail Price For Claims': stockLineEditInitialValues['Is Retail Price For Claims'],
              'Is Retail Price For Self Pay': stockLineEditInitialValues['Is Retail Price For Self Pay'],
              ...(this.props['Calories Per Unit'] && stockLineEditInitialValues['Quantity In Case']) ? {
                'Price per Box': formatPrice((stockLineEditInitialValues.Price * stockLineEditInitialValues['Quantity In Case']
                  * this.props['Calories Per Unit']) / 100),
                'Boxes Quantity': Math.round((stockLineEditInitialValues.Quantity / stockLineEditInitialValues['Quantity In Case'] / this.props['Calories Per Unit']) * 100),
              } : {},
            } : {
              'Hcpc Code ID': this.props['Main Hcpc Code'].ID,
              ...this.props['Last Arrival Stock Line'] && this.props['Last Arrival Stock Line'].ID ? {
                'Price per Unit': this.props['Last Arrival Stock Line'].Price
                  ? formatPrice(this.props['Last Arrival Stock Line'].Price) : '',
                'Units in Box': this.props['Last Arrival Stock Line']['Quantity In Case'],
                'Retail Price': this.props['Last Arrival Stock Line']['Retail Price']
                  ? formatPrice(this.props['Last Arrival Stock Line']['Retail Price']) : '',
                ...(this.props['Calories Per Unit'] && this.props['Last Arrival Stock Line']['Quantity In Case']) ? {
                  'Price per Box': formatPrice((this.props['Last Arrival Stock Line'].Price * this.props['Last Arrival Stock Line']['Quantity In Case']
                    * this.props['Calories Per Unit']) / 100),
                } : {},
                'Is Retail Price For Claims': this.props['Last Arrival Stock Line']['Is Retail Price For Claims'],
                'Is Retail Price For Self Pay': this.props['Last Arrival Stock Line']['Is Retail Price For Self Pay'],
                ...this.props['Last Arrival Stock Line'].Facility.ID ? {
                  'Facility Name': this.props['Last Arrival Stock Line'].Facility['Company Info']['Company Name'],
                  'Selected Facility Name': this.props['Last Arrival Stock Line'].Facility['Company Info']['Company Name'],
                  'Facility ID': this.props['Last Arrival Stock Line'].Facility.ID,
                } : {},
                ...!this.props['Last Arrival Stock Line'].Facility.ID && business.Facilities && business.Facilities.length === 1 ? {
                  'Facility Name': business.Facilities[0]['Company Info']['Company Name'],
                  'Selected Facility Name': business.Facilities[0]['Company Info']['Company Name'],
                  'Facility ID': business.Facilities[0].ID,
                } : {},
                ...this.props['Last Arrival Stock Line'].Warehouse.ID ? {
                  'Warehouse ID': this.props['Last Arrival Stock Line'].Warehouse.ID,
                  'Warehouse Location': this.props['Last Arrival Stock Line'].Warehouse.Location,
                  'Selected Warehouse Location': this.props['Last Arrival Stock Line'].Warehouse.Location,
                } : {},
              } : {},
            },
          }}
          Product={{
            'Product Name': this.props['Product Name'],
            Vendor,
            Model,
            'HCPC Codes': this.props['HCPC Codes'],
            Image,
            Category,
            Condition,
            Warehouse,
          }}
        />
        <InventoryStockLineHistoryViewDialog
          open={stockLineHistoryViewDialogOpen}
          onClose={this.onStockLineHistoryViewDialogClose}
          onStockLineEdit={this.onStockLineEdit}
          Product={{
            'Can Updated': this.props['Can Updated'],
            Category,
            Condition,
            'HCPC Codes': this.props['HCPC Codes'],
            ID,
            Image,
            'Last Arrival Stock Line': this.props['Last Arrival Stock Line'],
            'Main Hcpc Code': this.props['Main Hcpc Code'],
            Model,
            'Product Name': this.props['Product Name'],
            'Stock Line Balance': this.props['Stock Line Balance'],
            Vendor,
            Warehouse,
            'Calories Per Unit': this.props['Calories Per Unit'],
            'HCPC Codes': this.props['HCPC Codes'],
          }}
          business={business}
          fromInventory
        />
      </TableRow>
    );
  }
}

InventoryTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'Product Name': PropTypes.string.isRequired,
  'Retail Price': PropTypes.number,
  Vendor: PropTypes.shape({
    'Vendor Name': PropTypes.string,
    ID: PropTypes.number,
  }),
  Category: PropTypes.shape({
    Name: PropTypes.string,
    ID: PropTypes.number,
  }),
  Condition: PropTypes.shape({
    Name: PropTypes.string,
    ID: PropTypes.number,
  }),
  Warehouse: PropTypes.shape({
    Location: PropTypes.string,
    ID: PropTypes.number,
  }),
  Model: PropTypes.string,
  'Stock Line Balance': PropTypes.number,
  'Last Arrival Stock Line': PropTypes.shape({
    Quantity: PropTypes.number,
    Price: PropTypes.number,
  }),
  'HCPC Codes': PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape({
      'HCPC S Code': PropTypes.string,
      ID: PropTypes.number,
    })),
  ).isRequired,
  'Main Hcpc Code': PropTypes.shape({
    ID: PropTypes.number.isRequired,
  }).isRequired,
  'Can Updated': PropTypes.bool,
  Image: PropTypes.arrayOf(PropTypes.shape({
    'File Url': PropTypes.string,
    'File Name': PropTypes.string,
  })).isRequired,
  Facility: PropTypes.arrayOf(PropTypes.shape({
    'Company Name': PropTypes.string,
    ID: PropTypes.number,
  })),
  editFormValues: PropTypes.shape({
    'Product Name': PropTypes.string,
  }),
  copyFormValues: PropTypes.shape({
    'Product Name': PropTypes.string,
  }),
  actions: PropTypes.shape({
    deleteInventory: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  'Is Active': PropTypes.bool,
  onProductCopySuccess: PropTypes.func,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    linkProductName: PropTypes.string.isRequired,
    linkVendorName: PropTypes.string.isRequired,
    codesCell: PropTypes.string.isRequired,
    iconBox: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryTableRow.defaultProps = {
  Vendor: null,
  Category: null,
  Condition: null,
  Warehouse: null,
  editFormValues: null,
  copyFormValues: null,
  Model: null,
  'Retail Price': null,
  'Can Updated': true,
  'Last Arrival Stock Line': null,
  Facility: null,
  business: {},
  'Stock Line Balance': 0,
  'Is Active': true,
  onProductCopySuccess: () => {},
};

const mapStateToProps = (store, ownProps) => ({
  editFormValues: getFormValues(`${ownProps.ID}-inventoryEdit`)(store),
  copyFormValues: getFormValues(`${ownProps.ID}-inventoryCopy`)(store),
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    deleteInventory,
    change,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(InventoryTableRow),
);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryTable/InventoryTableRow.js